import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ExplanationSpanWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
  padding-bottom: 8px;
`;

export const LabelSpan = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const QuestionLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-bottom: 8px;
`;
